import { InitiativeComment } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { OffsetPaginatedResource, OffsetPaginationParams } from '@sonar-software/sonar-ts-types';

export type GetInitiativeCommentsRequest = OffsetPaginationParams & {
	initiativeId: number;
};

export type GetInitiativeCommentsResponse = OffsetPaginatedResource<InitiativeComment>;

export const getInitiativeComments = createGetEndpoint<GetInitiativeCommentsRequest, GetInitiativeCommentsResponse>(
	({ initiativeId, ...rest }) =>
		`/api/v2/initiatives/${initiativeId}/comments?sortBy=Date&sortDirection=Ascending&${getQueryString(rest)}`
);
